import {useInfiniteQuery} from "@tanstack/react-query";
import * as api from "../../../api";

const PAGE_SIZE = 20;

export const useStationInfiniteQuery = (filter, enabled=true) => {
    return useInfiniteQuery({
        queryKey: ['stations', filter],
        queryFn: async ({pageParam=0}) => {
            const data = await api.Station.getStations({...filter, page_index: pageParam, page_size: PAGE_SIZE});
            return {
                items: data.rows,
                nextPage: data.rows.length === PAGE_SIZE ? pageParam + 1 : undefined,
            };
        },
        getNextPageParam: (lastPage) => lastPage.nextPage,
        enabled: enabled,
    })
}